import React, { forwardRef } from 'react';
import * as RAvatar from '@radix-ui/react-avatar';
import clsx from 'clsx';
import { avatar as avatarClass, fallback as fallbackClass } from './avatar.module.css';
export const Avatar = forwardRef(({ className, fallback = 'S', src, size = 'regular', backgroundColor, style, ...props }, forwardedRef) => (React.createElement(RAvatar.Root, { className: clsx(avatarClass, className), "data-background": backgroundColor, ref: forwardedRef, style: { ...style }, "data-avatar-size": size, ...props },
    React.createElement(RAvatar.Image, { src: src }),
    React.createElement(RAvatar.Fallback, { className: fallbackClass }, String(fallback).charAt(0)))));
Avatar.displayName = 'Avatar';
